(() => {
  const fillEnquiry = () => {
    const handle = new URLSearchParams(window.location.search).get('product');
    const message = document.querySelector('#ContactForm-body');
    if (!handle || !message || message.value.trim() || !/^[a-z0-9-]{1,200}$/.test(handle)) return;
    const url = new URL(`products/${handle}`, window.location.origin + (window.Shopify?.routes?.root || '/'));
    message.value = `I have a question about this item:\n${url.href}\n\n`;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillEnquiry, {once: true});
  else fillEnquiry();
})();
